import { AUTH_API_BASE, OPERATIONS_API_BASE } from '../../config/api';
import React, { useState, useEffect } from 'react';
import { useIsFocused } from "@react-navigation/native";
import {
  View,
  SafeAreaView,
  Text,
  Image,
  StyleSheet,
  Dimensions,
  ScrollView,
  TouchableHighlight,
  Platform,
  ImageBackground
} from 'react-native';

import AsyncStorage from '@react-native-async-storage/async-storage';
import * as Notifications from 'expo-notifications';

import { FontAwesome5 } from '@expo/vector-icons';
import { FontAwesome } from '@expo/vector-icons';

import logo from './assets/logo.png';
import backg from './assets/backg.jpg';

import { isWeb } from '../../utils/platform';

const screenWidth = Math.round(Dimensions.get('window').width);
const screenHeight = Math.round(Dimensions.get('window').height);

/*
 * Backend utilizado pelo painel administrativo e pelo login.
 */
const API_BASE = 'https://superfrio-back-dev.vercel.app';


async function registerForPushNotificationsAsync() {

  /*
   * Push notification não é necessário no navegador.
   */
  if (isWeb) {
    return;
  }

  try {

    const iduser = await AsyncStorage.getItem('sfuserid');

    const { status: existingStatus } =
      await Notifications.getPermissionsAsync();

    let finalStatus = existingStatus;

    if (existingStatus !== 'granted') {

      const { status } =
        await Notifications.requestPermissionsAsync();

      finalStatus = status;
    }

    if (finalStatus !== 'granted') {
      alert('Não foi possível obter token!');
      return;
    }

    const token = (
      await Notifications.getExpoPushTokenAsync()
    ).data;

    /*
     * Atualiza o token do usuário no backend correto.
     */
    await fetch(
      `${AUTH_API_BASE}/usuarios/${iduser}`,
      {
        method: 'PUT',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          pushToken: token
        }),
      }
    );

    if (Platform.OS === 'android') {

      await Notifications.setNotificationChannelAsync(
        'default',
        {
          name: 'default',
          importance:
            Notifications.AndroidImportance.MAX,
          vibrationPattern: [0, 250, 250, 250],
          lightColor: '#FF231F7C',
        }
      );
    }

    /*
     * Contadores utilizados para badge.
     */
    const responsePit = await fetch(
      `${API_BASE}/checklistpit/countDocs`
    );

    const dataPit = await responsePit.json();


    const responseComp = await fetch(
      `${OPERATIONS_API_BASE}/checklistcomp/countDocs`
    );

    const dataComp = await responseComp.json();


    const responseCompExit = await fetch(
      `${OPERATIONS_API_BASE}/checklistcomp/count/docs/exit`
    );

    const dataCompExit =
      await responseCompExit.json();


    const responseRack = await fetch(
      `${API_BASE}/checklistrack/countDocs`
    );

    const dataRack =
      await responseRack.json();


    if (
      dataComp.totalRecords0 ||
      dataPit.totalRecords0 ||
      dataCompExit.totalRecords0 ||
      dataRack.totalRecords0
    ) {

      const pendItens =
        parseInt(dataComp.totalRecords0 || 0) +
        parseInt(dataPit.totalRecords0 || 0) +
        parseInt(dataCompExit.totalRecords0 || 0) +
        parseInt(dataRack.totalRecords0 || 0);

      await Notifications.setBadgeCountAsync(
        pendItens
      );

    } else {

      await Notifications.setBadgeCountAsync(0);
    }

  } catch (error) {

    console.error(
      'Erro ao registrar notificações:',
      error
    );
  }
}


const Home = ({ navigation }) => {

  const [windowDimensions, setWindowDimensions] =
    useState(Dimensions.get('window'));

  const [nome, setNome] = useState("");

  const [showcomp, setShowcomp] =
    useState(false);

  const [showpit, setShowpit] =
    useState(false);

  const [showrack, setShowrack] =
    useState(false);

  const [showdespesas, setShowdespesas] =
    useState(true);

  const [countComp, setCountComp] =
    useState({});

  const [countCompExit, setCountCompExit] =
    useState({});

  const [countPit, setCountPit] =
    useState({});

  const [countRack, setCountRack] =
    useState({});

  const [countDesp, setCountDesp] =
    useState("");

  const [apprdesp, setApprdesp] =
    useState(false);


  /*
   * Atualização de tamanho da tela.
   */
  useEffect(() => {

    const handleResize = ({ window }) => {
      setWindowDimensions(window);
    };

    const subscription =
      Dimensions.addEventListener(
        'change',
        handleResize
      );

    return () => {
      subscription?.remove();
    };

  }, []);


  /*
   * Carrega usuário e permissões.
   */
  async function getStorageValue() {

    try {

      const nomeStorage =
        await AsyncStorage.getItem(
          'sfusernome'
        );

      setNome(nomeStorage || '');


      const apprDespStorage =
        await AsyncStorage.getItem(
          'sfdespappr'
        );

      setApprdesp(
        apprDespStorage === 'true'
      );


      const comp =
        await AsyncStorage.getItem(
          'sfcomp'
        );

      const pit =
        await AsyncStorage.getItem(
          'sfpit'
        );

      const rack =
        await AsyncStorage.getItem(
          'sfrack'
        );

      const admin =
        await AsyncStorage.getItem(
          'sfadmin'
        );


      if (
        comp === 'true' ||
        admin === 'true'
      ) {

        setShowcomp(true);
      }


      if (
        pit === 'true' ||
        admin === 'true'
      ) {

        setShowpit(true);
      }


      if (
        rack === 'true' ||
        admin === 'true'
      ) {

        setShowrack(true);
      }


      /*
       * Confirma que o usuário ainda existe.
       *
       * Antes este trecho apontava para
       * superfriosrapp.com.
       *
       * Agora utiliza o mesmo backend do login.
       */
      const userid =
        await AsyncStorage.getItem(
          'sfuserid'
        );


      if (!userid) {

        await AsyncStorage.clear();

        navigation.navigate('Login');

        return;
      }


      const response = await fetch(
        `${AUTH_API_BASE}/usuarios/${userid}`
      );


      if (!response.ok) {
        if (response.status === 400 || response.status === 404) {
          await AsyncStorage.clear();
          navigation.navigate('Login');
        }
        return;
      }
      const data = await response.json();
      const currentUser = Array.isArray(data) ? data[0] : data;


      /*
       * O endpoint normalmente retorna um array.
       */
      if (
        data?.error || !currentUser?._id || currentUser.access_app !== true
      ) {

        await AsyncStorage.clear();

        navigation.navigate('Login');

        return;
      }

      // As permissões mais recentes do painel também controlam os módulos exibidos.
      setShowcomp(currentUser.access_comp === true || currentUser.admin === true);
      setShowpit(currentUser.access_pit === true || currentUser.admin === true);
      setShowrack(currentUser.access_rack === true || currentUser.admin === true);
      setShowdespesas(currentUser.access_despesa === true || currentUser.admin === true);
      setApprdesp(currentUser.desp_appr === true);
      await AsyncStorage.setItem('sfdespappr', String(currentUser.desp_appr === true));

    } catch (error) {

      /*
       * Um problema temporário de rede não deve
       * apagar a sessão do usuário.
       */
      console.error(
        'Erro ao validar usuário:',
        error
      );
    }
  }


  /*
   * Carrega os contadores da Home.
   */
  async function loadCounts() {
    const userid = await AsyncStorage.getItem('sfuserid');
    const canApprove = await AsyncStorage.getItem('sfdespappr');
    const requests = [
      [`${OPERATIONS_API_BASE}/checklistcomp/countDocs`, setCountComp],
      [`${OPERATIONS_API_BASE}/checklistcomp/count/docs/exit`, setCountCompExit],
      [`${API_BASE}/checklistpit/countDocs`, setCountPit],
      [`${API_BASE}/checklistrack/countDocs`, setCountRack],
    ];
    if (canApprove === 'true' && userid) {
      requests.push([`${OPERATIONS_API_BASE}/despesa/pending/count/${userid}`, setCountDesp]);
    }
    await Promise.allSettled(requests.map(async ([url, update]) => {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      update(await response.json());
    }));
  }


  /*
   * Primeira carga da Home.
   */
  useEffect(() => {

    getStorageValue();

    registerForPushNotificationsAsync();

    loadCounts();

  }, []);


  /*
   * Atualiza os contadores quando a Home
   * volta a ficar em foco.
   */
  const isFocused =
    useIsFocused();


  useEffect(() => {

    if (isFocused) {
      getStorageValue();
      loadCounts();
    }

  }, [isFocused]);


  const modules = [
    { visible: showcomp, title: 'Compressores', detail: 'Checklists de entrada e saída', icon: 'gears', route: 'CompPreIndexType', count: Number(countComp.totalRecords0 || 0) + Number(countCompExit.totalRecords0 || 0) },
    { visible: showpit, title: 'Pit-Stop', detail: 'Inspeções e acompanhamento', icon: 'store', route: 'PitPreIndex', count: Number(countPit.totalRecords0 || 0) },
    { visible: showrack, title: 'Rack Frio', detail: 'Controle dos equipamentos', icon: 'th-large', route: 'RackPreIndex', count: Number(countRack.totalRecords0 || 0) },
    { visible: showdespesas, title: 'Despesas', detail: 'Relatórios e aprovações', icon: 'credit-card', route: 'DespesasPreIndex', count: Number(countDesp || 0) },
  ].filter(module => module.visible);
  return (
    <SafeAreaView style={styles.backContainer}>
      <ScrollView contentContainerStyle={styles.page}>
        <View style={styles.brandHeader}>
          <Image source={logo} resizeMode="contain" style={styles.logo} />
          <View style={styles.brandBadge}><Text style={styles.brandBadgeText}>PORTAL OPERACIONAL</Text></View>
        </View>
        <View style={styles.welcome}>
          <Text style={styles.eyebrow}>SEU DIA, MAIS ORGANIZADO</Text>
          <Text style={styles.title}>Olá{nome ? `, ${nome.split(' ')[0]}` : ''}.</Text>
          <Text style={styles.subtitle}>Acesse os módulos e acompanhe sua operação.</Text>
        </View>
        <View style={styles.sectionHeader}>
          <Text style={styles.sectionTitle}>Área de trabalho</Text>
          <Text style={styles.sectionCount}>{modules.length} módulos</Text>
        </View>
        <View style={styles.grid}>
          {modules.map(module => (
            <TouchableHighlight key={module.route} style={styles.moduleCard}
              underlayColor="#eaf0f8" accessibilityRole="button" accessibilityLabel={module.title}
              onPress={() => navigation.navigate(module.route)}>
              <View style={styles.cardBody}>
                <View style={styles.cardTop}>
                  <View style={styles.iconTile}>
                    {module.icon === 'store' ? <FontAwesome5 name="store" size={24} color="#003c84" /> : <FontAwesome name={module.icon} size={24} color="#003c84" />}
                  </View>
                  {module.count > 0 && <View style={styles.badge}><Text style={styles.badgeText}>{module.count}</Text></View>}
                </View>
                <Text style={styles.cardTitle}>{module.title}</Text>
                <Text style={styles.cardDescription}>{module.detail}</Text>
                <View style={styles.cardFooter}><Text style={styles.cardLink}>Acessar</Text><FontAwesome name="arrow-right" size={13} color="#003c84" /></View>
              </View>
            </TouchableHighlight>
          ))}
        </View>
        <Text style={styles.footer}>SUPER FRIO • Gestão em movimento</Text>
      </ScrollView>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  backContainer: { flex: 1, backgroundColor: '#f4f7fb' },
  page: { width: '100%', maxWidth: 760, alignSelf: 'center', paddingHorizontal: 20, paddingTop: 24, paddingBottom: 32 },
  brandHeader: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 },
  logo: { width: 148, height: 50 },
  brandBadge: { backgroundColor: '#e8eef7', borderRadius: 8, paddingHorizontal: 10, paddingVertical: 7 },
  brandBadgeText: { color: '#003c84', fontSize: 9, fontWeight: '700', letterSpacing: 1 },
  welcome: { backgroundColor: '#003c84', borderRadius: 24, padding: 24, marginTop: 24, marginBottom: 28 },
  eyebrow: { fontSize: 10, fontWeight: '700', letterSpacing: 1.5, color: '#d4e2f5', marginBottom: 12 },
  title: { color: '#fff', fontSize: 30, fontWeight: '700', marginBottom: 8 },
  subtitle: { color: '#e4edf8', fontSize: 15, lineHeight: 23 },
  sectionHeader: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 },
  sectionTitle: { fontSize: 18, color: '#00004C', fontWeight: '700' },
  sectionCount: { fontSize: 12, color: '#63758c' },
  grid: { flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between', gap: 12 },
  moduleCard: { width: '47%', flexGrow: 1, backgroundColor: '#fff', borderWidth: 1, borderColor: '#e1e8f2', borderRadius: 20, overflow: 'hidden' },
  cardBody: { padding: 16, minHeight: 188 },
  cardTop: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 },
  iconTile: { width: 46, height: 46, borderRadius: 14, backgroundColor: '#edf3fb', alignItems: 'center', justifyContent: 'center' },
  badge: { backgroundColor: '#e32636', borderRadius: 12, minWidth: 24, paddingHorizontal: 6, paddingVertical: 4 },
  badgeText: { color: '#fff', fontSize: 11, fontWeight: '700' },
  cardTitle: { fontSize: 16, fontWeight: '700', color: '#00004C', marginBottom: 6 },
  cardDescription: { fontSize: 12, lineHeight: 18, color: '#63758c', minHeight: 36 },
  cardFooter: { marginTop: 16, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' },
  cardLink: { color: '#003c84', fontWeight: '700', fontSize: 12 },
  footer: { textAlign: 'center', fontSize: 10, letterSpacing: 1, color: '#63758c', marginTop: 28 },
});

export default Home;
